import { getDocByUID, getDocs } from "shared/prismic";
import { ReviewsFormPage } from "containers/ReviewsFormPage";

const PAGE_TYPE = "course_detail";

export async function getStaticProps({ preview = null, previewData, params }) {
  const doc = await getDocByUID({
    previewData,
    uid: params.uid,
    type: PAGE_TYPE,
  });
  return { props: { doc, preview } };
}

export async function getStaticPaths() {
  const pages = await getDocs({ type: PAGE_TYPE });
  const paths = pages.map(({ uid }) => ({ params: { uid } }));
  return { paths, fallback: false };
}

export default ReviewsFormPage;
